import { CurrencyCode } from 'types/currency';

import { makeLabels } from 'utils/i18n';

export const BREADCRUMBS = [
  ['breadcrumbs.cryptoPayout', 'Create Payout'],
  ['breadcrumbs.agentDashboard', 'Customer Payout'],
];

const NAMESPACE = 'page.cryptoPayout.agentDashboard';
export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['title', 'Customer Payout'],
    LOADING_ERROR: ['loadingError', 'An error occurred while loading the crypto payout. Please try again later.'],
    CANCELLED_MESSAGE: ['cancelledMessage', 'The payout has been cancelled.'],
    START_OVER: ['startOver', 'Create New Payout'],
  },
  NAMESPACE,
);

export const KEYS = {
  HARDCODED_CURRENCY: CurrencyCode.USD,
};
